import React from "react";
import styled from "styled-components";
import { Formik, Form as FormikForm } from "formik";
import { spacing } from "globalStyles";
import * as Yup from "yup";
import { useAppContext } from "providers/App";
import { errorToast, successToast } from "ui/Toasts/Toast";
import { submitSubscriptionClient } from "api/newsletter";
import { SubscriptionClient as SubscriptionClientProps } from "interfaces/content";
import InputField from "ui/Input/form/InputField";
import Button from "ui/Button";
import Heading from "ui/Text/Heading";
import FlexBox from "ui/FlexBox";

interface FormValues {
  name: string;
  email: string;
  phone: string;
}

export const SubscriptionClient: React.FC<SubscriptionClientProps> = ({ ...data }) => {
  const { setIsLoading } = useAppContext();

  const initialValues: FormValues = {
    name: "",
    email: "",
    phone: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("O campo nome deverá ser preenchido"),
    email: Yup.string()
      .required("O campo email deverá ser preenchido")
      .email("O campo email é inválido"),
    phone: Yup.string().required("O campo telefone deverá ser preenchido"),
  });

  const onSubmit = async (values: FormValues) => {
    setIsLoading(true);

    const { success } = await submitSubscriptionClient(
      { name: values.name, email: values.email, phone: values.phone },
      data.apiUrl,
    );

    setIsLoading(false);

    if (!success) {
      errorToast({
        text: "Ocorreu um erro ao submeter o pedido de cliente avençado",
        options: { autoClose: false },
      });
      return;
    }

    successToast({ text: "Pedido de cliente avençado realizado com sucesso" });
  };

  return (
    <Container className="content-container large-padding" flexDirection="column">
      <Title variant="h2" align="center">
        {data.title}
      </Title>
      <Subtitle variant="h5" align="center" color="secondary">
        {data.subtitle}
      </Subtitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <FlexBox flexDirection="column" gap="16px" alignItems="center">
            <InputRow>
              <InputField type="text" name="name" placeholder={data.fields.name} />
            </InputRow>
            <InputRow>
              <InputField type="email" name="email" placeholder={data.fields.email} />
              <InputField type="text" name="phone" placeholder={data.fields.phone} />
            </InputRow>
            <ButtonWrapper justify="center">
              <Button height={42} type="submit">
                {data.buttonText}
              </Button>
            </ButtonWrapper>
          </FlexBox>
        </FormikForm>
      </Formik>
    </Container>
  );
};

const Container = styled(FlexBox)`
  max-width: 100%;
  height: auto;
  align-items: unset;
  min-height: 305px;
  background-color: ${({ theme }) => theme.colors.tertiary};
  border-radius: 8px;

  &.content-container.large-padding {
    padding: ${spacing.large}px;
  }
`;

const Title = styled(Heading)`
  margin-top: ${spacing.large}px;
`;

const Subtitle = styled(Heading)`
  margin: ${spacing.extraSmall}px 0 ${spacing.large}px 0;
`;

const InputRow = styled(FlexBox)`
  gap: 16px;
  width: 100%;
`;

const ButtonWrapper = styled(FlexBox)`
  margin-top: ${spacing.small}px;
`;
